import { render, staticRenderFns } from "./BrandTutorialVideoPopup.vue?vue&type=template&id=f6f8a08e&scoped=true&"
import script from "./BrandTutorialVideoPopup.vue?vue&type=script&lang=js&"
export * from "./BrandTutorialVideoPopup.vue?vue&type=script&lang=js&"
import style0 from "./BrandTutorialVideoPopup.vue?vue&type=style&index=0&id=f6f8a08e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f8a08e",
  null
  
)

export default component.exports